import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerChopSignService {

  constructor(
    private http: HttpClient
  ) {

  }

  /**
   * get Customer ChopSign
   * @param doNo do No.
   * @returns
   */
  getCustomerChopsign(doNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/CustomerChopSign/${doNo}`;
    return this.http.get(url);
  }

  updateEffectiveEndDate(updateObj: any): Observable<any>{
    var seqNo = updateObj.seqNo;
    var params = {
      effectiveEndDate: updateObj.effectiveEndDate,
      userId: updateObj.userId
    };
    const url = `${environment.logisticsApiUrl}/CustomerChopSign/${seqNo}/EffectiveEndDate`;
    return this.http.patch(url, params);
  }

  uploadCustomerChopSign(file: any, model: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/CustomerChopSign`;

    const formData: FormData = new FormData();

    formData.append('json', JSON.stringify(model));
    formData.append('file', file, file.name);

    let response = this.http.post(url, formData, { reportProgress: true, observe: 'events' });
    return response;
  }

  getImgUrl(sn: string): string{
    return `${environment.logisticsApiUrl}/CustomerChopSign/chopSign/${sn}`;
  }
}
